import { render, staticRenderFns } from "./PropertySubtype.vue?vue&type=template&id=cace6f5e&"
import script from "./PropertySubtype.vue?vue&type=script&lang=ts&"
export * from "./PropertySubtype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports